export default __webpack_public_path__ + "static/media/line-plot-number-line-blue.ee2381b3.svg";